import { Button } from "antd";

/** Up to two initials from a name: "Dana Reyes" → "DR". */
export const initialsOf = (name) =>
  String(name ?? "")
    .split(/\s+/)
    .filter(Boolean)
    .map((part) => part[0].toUpperCase())
    .slice(0, 2)
    .join("");

/** A card footer button: icon-only with a spoken name, or icon + label. */
export const CardAction = ({ label, icon, children, ...props }) => (
  <Button size="large" aria-label={children ? undefined : label} icon={icon} {...props}>
    {children}
  </Button>
);

/**
 * The one card shape every phone list uses (Card A): who or what the row is
 * up top with its status control, the details someone scans in the middle,
 * then a footer line and the row's buttons.
 */
const ListCard = ({
  title,
  name,
  subtitle,
  initials,
  media,
  muted = false,
  status,
  children,
  meta,
  actions,
}) => (
  <article
    // `name` labels the card when `title` is a control (e.g. a link button).
    aria-label={name ?? (typeof title === "string" ? title : undefined)}
    className="flex flex-col gap-2.5 rounded-[10px] border border-gray-200 bg-white px-3.5 py-3 text-secondary"
  >
    <div className="flex items-center gap-2.5">
      {/* A picture of the row (e.g. a listing photo) takes the avatar's place. */}
      {media && <div className="shrink-0">{media}</div>}
      {!media && initials !== undefined && (
        <span
          aria-hidden="true"
          className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[13px] font-extrabold ${
            muted ? "bg-gray-100 text-gray-500" : "bg-light_green text-[#4a5513]"
          }`}
        >
          {initials}
        </span>
      )}
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="break-words text-[15px] font-bold text-gray-900">{title}</span>
        {subtitle && <span className="text-xs text-gray-600">{subtitle}</span>}
      </div>
      {status && <div className="shrink-0">{status}</div>}
    </div>

    {children && (
      <div className="flex min-w-0 flex-col gap-0.5 break-words text-[13px] text-gray-700">
        {children}
      </div>
    )}

    {(meta || actions) && (
      <div className="flex items-center justify-between gap-2 border-t border-gray-100 pt-2">
        <div className="flex min-w-0 flex-col text-xs text-gray-600">{meta}</div>
        {actions && <div className="flex shrink-0 flex-wrap justify-end gap-1">{actions}</div>}
      </div>
    )}
  </article>
);

export default ListCard;
